import React from "react";
import { Users2 as _u } from "lucide-react";

export const MODULE_LABELS = {
  dashboard: "Painel",
  service_cases: "Casos de Serviço",
  body_shop_cases: "Bate-chapas (BPS)",
  tasks: "Tarefas",
  parts_requests: "Pedidos de Peças",
  parts_bench_orders: "Peças de Balcão (PEB)",
  customer_feedback: "Feedback do Cliente",
  classification_requests: "Pedidos de Classificação",
  warranty_claims: "Garantias",
  maintenance_plans: "Planos de Manutenção",
  vehicle_registrations: "Registo de Viaturas",
  vehicle_quotes: "Cotações de Viatura",
  crm: "CRM",
  reports: "Relatórios",
  admin_settings: "Administração",
};

export const inputCls = "w-full mt-0.5 px-2 py-1.5 border border-gray-300 rounded-sm text-sm focus:outline-none focus:ring-2 focus:ring-[#1F3864]/30";

export function Badge({ children, tone = "blue" }) {
  const cls = {
    blue: "bg-[#E0E7FF] text-[#1E3A8A]",
    green: "bg-[#D4EDDA] text-[#155724]",
    amber: "bg-[#FFF3CD] text-[#856404]",
    grey: "bg-[#E2E8F0] text-[#495057]",
    red: "bg-[#F8D7DA] text-[#721C24]",
  }[tone];
  return <span className={`inline-block text-[10px] font-semibold uppercase tracking-wider px-1.5 py-0.5 rounded-sm ${cls}`}>{children}</span>;
}


export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-[10px] uppercase tracking-widest text-[#6C757D]">{label}</span>
      {children}
    </label>
  );
}


export function Section({ title, icon: Icon, children }) {
  return (
    <div className="border border-gray-200 rounded-md p-4">
      <div className="flex items-center gap-2 mb-3">
        {Icon && <Icon className="w-4 h-4 text-[#1F3864]" />}
        <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-[#1A1A2E]">{title}</h3>
      </div>
      {children}
    </div>
  );
}


export function Note({ tone = "info", children }) {
  const cls = tone === "warn"
    ? "bg-[#FFF3CD] text-[#856404] border-[#FFC107]/40"
    : tone === "info"
      ? "bg-[#E0E7FF] text-[#1E3A8A] border-[#1F3864]/30"
      : "bg-[#F4F6F8] text-[#6C757D] border-gray-200";
  return <div className={`mt-2 text-xs border px-2 py-1.5 rounded-sm ${cls}`}>{children}</div>;
}



/**
 * Iter 60 — reutilizável para mostrar `warnings[]` devolvidos pelos PUTs
 * de admin (system-settings, alert-settings, digest recipients, etc.).
 * Uso: `showAdminSaveToast({ savedLabel, warnings })`.
 */
import { toast } from "sonner";

export function showAdminSaveToast({ savedLabel = "Guardado", warnings = [] } = {}) {
  if (!warnings || warnings.length === 0) {
    toast.success(savedLabel);
    return;
  }
  toast.warning(`${savedLabel} · ${warnings.length} aviso${warnings.length === 1 ? "" : "s"}`, {
    description: warnings.slice(0, 5).join("\n") + (warnings.length > 5 ? `\n… (+${warnings.length - 5} mais)` : ""),
    duration: 8000,
  });
}
